import React from "react";
import { IconLink, PrimaryButton, PrimaryLink } from "../index";

export default function SuperButton(props) {
  const ctaTypeName = props.ctaType ? props.ctaType : props.ctatype;
  let ctaTypeVal = ctaTypeName && ctaTypeName.fields ? ctaTypeName.fields.phrase.value : ctaTypeName;
  ctaTypeVal = props.defaultType ? props.defaultType : ctaTypeVal;
  switch (ctaTypeVal) {
    case "primary-button":
      return <PrimaryButton {...props} />;
    case "icon-link":
      return <IconLink {...props} />;
    case "primary-link":
      return <PrimaryLink {...props} />;
    default:
      return null;
  }
}
